module.exports = __webpack_public_path__ + "static/media/WMPCA_vertical_Lrg.ceab4596.jpg";